import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import styled from "styled-components";
import WOW from "wowjs";
import { FaFilm, FaBullhorn, FaCar, FaPlane, FaGlobeAfrica } from "react-icons/fa";
import { Link } from "react-router-dom";
import Services from "./Services";

// Styled Components
const ServiceDetail = styled.section`
  padding: 80px 0;
  &.bg-light {
    background-color: #f8f9fa;
  }
  .service-header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    .service-icon {
      font-size: 36px;
      color: #e27d60;
      margin-right: 15px;
    }
    h2 {
      font-size: 32px;
      font-weight: 700;
      margin: 0;
    }
  }
`;

// Service Data
const services = [
  {
    id: "entertainment",
    imageBig: "entertainment.jpg",
    imageSmall: "entertainment_small.jpg",
    icon: <FaFilm />,
    title: "Entertainment and Culture",
    description: [
      "We inspire people to take delight in promoting and supporting societal development using the power of entertainment irrespective of diversity; upholding our beliefs in race, ethnicity, norms and the value of humanity. Through this service, we create programmes that drive cultural development and societal upliftment and infuse them with entertainment, thus making them attractive for our audience’s participation.",
      "For brands that are willing to make meaningful impact in the society, our entertainment and culture programmes serve as veritable CSR platforms to create meaningful change in the society.",
      <>
        Our flagship programme under this service is{" "}
        <Link to={"/projects#concept-transformation"}>
          <strong>Heroes of Tomorrow</strong>
        </Link>{" "}
        aimed at actively getting out-of-school children into schools, by
        sponsoring their education, particularly focusing on children who are
        out-of-school due to poverty.
      </>,
    ],
    links: [{ to: "/contact", text: "Be A Partner" }],
    list: false,
  },
  {
    id: "branding",
    imageBig: "branding.jpg",
    imageSmall: "branding_small.jpg",
    icon: <FaBullhorn />,
    title: "Branding and Advertising",
    description: [
      "We offer a unique combination of creative expertise, strategic thinking, and passion for delivering exceptional results for brands, products and services. Our team is dedicated to helping you achieve your business objectives and establish a strong brand presence in the Nigerian market.",
      "Our services under Branding and Advertising include:",
      "list",
      "We're excited about the opportunity to collaborate with you and bring your brand story to life. Let's work together to create a campaign that drives real results and leaves a lasting impression on your audience.",
    ],
    list: true,
    lists: [
      <>
        <strong>Word-of-Mouth:</strong> the best form of marketing still remains
        word-of-mouth. We help clients develop effective word-of-mouth campaigns
        that elicit trust, organic attractions and impactful results for
        businesses.
      </>,

      <>
        <strong>Experiential Campaigns:</strong> we create memorable and
        interactive experiences for your customers, allowing them to directly
        engage with your brand through activities, events, or environments, thus
        helping them to build deeper emotional connections with your product or
        service.
      </>,
      <>
        <strong>Website Adverts:</strong> for brands wishing to hold events,
        campaign launches, product or service awareness campaigns and more, we
        offer Ad services on our website.
      </>,
    ],
    links: [{ to: "/contact", text: "Contact Us" }],
    bgLight: true,
  },
  {
    id: "automobile",
    imageBig: "automobile.jpg",
    imageSmall: "automobile_small.jpg",
    icon: <FaCar />,
    title: "Automobile Purchase/Sales",
    description: [
      "We ship new and pre-owned safe, reliable, and affordable vehicles from the United States to destinations in Africa. We achieve this through:",
      "list",
      "We are driven by a passion for excellence, integrity, and customer satisfaction. Our goal is to be the go-to automobile sales provider for cars shipped to African destinations, trusted for our commitment to quality, reliability, and exceptional service.",
    ],
    links: [{ to: "/contact", text: "Contact Us" }],
    list: true,
    lists: [
      <>
        A diverse portfolio of new and pre-owned vehicles from renowned global
        manufacturers and verified owners
      </>,

      <>Transparent and competitive pricing</>,
      <>Expert sales and after-sales support</>,
    ],
  },
  {
    id: "tourism",
    imageBig: "tourism.jpg",
    imageSmall: "tourism_small.jpg",
    icon: <FaPlane />,
    title: "Tourist Services",
    description: [
      "We specialize in providing exceptional travel services to travelers visiting Nigeria, South Africa, Ghana, Kenya and the United States of America. Our mission is to ensure that your journey is seamless, stress-free, and filled with unforgettable memories. Our services include:",
      "list",
      <>
        We offer <strong>Personalised Service</strong> with a team that takes
        the time to understand your unique needs and preferences,{" "}
        <strong>Local Expertise</strong> with our extensive knowledge of South
        Africa, Ghana, and the USA, and <strong>Competitive Pricing</strong>{" "}
        without compromising on quality, ensuring that you receive exceptional
        value for your money.
      </>,
    ],

    list: true,
    lists: [
      <>
        <strong>Hotel Reservations:</strong> We offer a wide range of carefully
        selected hotels to suit your budget and preferences, ensuring a
        comfortable and relaxing stay.
      </>,

      <>
        <strong>Airport Pickup:</strong>We organise friendly and professional
        drivers who will greet you at the airport and transport you safely to
        your hotel, eliminating any hassle or uncertainty.
      </>,
      <>
        <strong>Ground Trips:</strong> Explore the sights and sounds of your
        destination with our guided ground trips, tailored to your interests and
        schedule.
      </>,
    ],

    links: [{ to: "/contact", text: "Contact Us" }],
    bgLight: true,
  },
  {
    id: "diaspora",
    imageBig: "diaspora-fused.jpg",
    imageSmall: "diaspora-sm.jpg",
    icon: <FaGlobeAfrica />,
    title: "Diaspora Bridge Services",
    description: [
      "Living abroad but need someone you can trust on the ground in Nigeria? Our Diaspora Bridge Services are designed exactly for you. As Nigerians in the diaspora, we understand how difficult it can be to manage everyday tasks back home from thousands of miles away — and that is where we come in.",
      "Through our Diaspora Bridge Services we serve as your reliable personal assistant in Nigeria, helping you coordinate errands, projects, and personal matters while keeping you informed every step of the way. Our services include:",
      "list",
      "Our goal is simple: to help you get things done in Nigeria without having to travel back yourself. We communicate clearly, provide regular updates, and treat every assignment with professionalism, consistency, and care.",
    ],
    list: true,
    lists: [
      <>
        <strong>Property and Home Oversight:</strong> property visits and basic
        visual checks, photos and videos of locations, coordination of cleaning
        services, tenant rent collection and property management follow-up.
      </>,
      <>
        <strong>Family and Personal Care:</strong> hospital visits and elderly
        parent check-ups with written reports, checking on relatives or ongoing
        projects, school-related services and PTA representation, and standing
        in for you at events such as weddings and funerals.
      </>,
      <>
        <strong>Shopping and Deliveries:</strong> personal shopping, gift
        purchases and surprise deliveries, supermarket price checks, and pickup
        and delivery coordination.
      </>,
      <>
        <strong>Documents and Errands:</strong> document collection and
        delivery, general errand services, paying or confirming approved local
        expenses, and airport and transport coordination.
      </>,
      <>
        <strong>Verification and Follow-up:</strong> business verification,
        follow-ups with service providers and offices, calls to local
        businesses or individuals, and connecting you with verified Nigerian
        service providers — all backed by clear, simple progress reports.
      </>,
    ],
    links: [{ to: "/contact", text: "Talk To Us" }],
  },
];

const WhatWeDoComponent = () => {
  useEffect(() => {
    new WOW.WOW({ live: false }).init();
  }, []);

  return (
    <>
      {services.map((service, index) => (
        <ServiceDetail
          key={service.id}
          id={service.id}
          className={service.bgLight ? "bg-light" : ""}
        >
          <Services service={service} />
        </ServiceDetail>
      ))}
    </>
  );
};

export default WhatWeDoComponent;
